import React from 'react'
import PropTypes from 'prop-types'
import constants from './constants'
import Placeholder from './Placeholder'
import ReactPlaceholder from 'react-placeholder'
import imagePlaceHolder from '@loyal_images/products/product_placeholder.png'

const ProductImage = props => {
  var img
  var src
  var alt = ''
  if (props.vendorType === 'Compra de Pontos') {
    src = constants.VENDOR.PURCHASEPOINTS.IMAGEURL
    alt = props.alt
  } else if (props.vendorType === 'Doação') {
    src = constants.VENDOR.DONATION.IMAGEURL
    alt = props.alt
  } else if (props.vendorType === 'Recarga Celular') {
    src = constants.VENDOR.CELLPHONERECHARGE.IMAGEURL
    alt = props.alt
  } else {
    switch (props.vendorId) {
      case constants.VENDOR.SMILES.ID:
        src = constants.VENDOR.SMILES.IMAGEURL
        alt = props.alt
        break
      case constants.VENDOR.SHELL.ID:
        src = constants.VENDOR.SHELL.IMAGEURL
        alt = props.alt

        break
      case constants.VENDOR.PAYBILLS.ID:
        src = constants.VENDOR.PAYBILLS.IMAGEURL
        alt = props.alt
        break
      case constants.VENDOR.PURCHASEPOINTS.ID:
        src = constants.VENDOR.PURCHASEPOINTS.IMAGEURL
        alt = props.alt
        break
      case constants.VENDOR.DONATION.ID:
        src = constants.VENDOR.DONATION.IMAGEURL
        alt = props.alt
        break
      case constants.VENDOR.CELLPHONERECHARGE.ID:
        var srcRecharge
        var altRecharge

        for (var property in constants.OPERATORS) {
          var operator = constants.OPERATORS[property]
          if (
            props.alt.toUpperCase().indexOf(operator.description.toUpperCase()) > -1
          ) {
            srcRecharge = operator.IMAGEURL
            altRecharge = operator.description
            break
          }
        }

        src = srcRecharge || constants.VENDOR.CELLPHONERECHARGE.IMAGEURL
        alt = altRecharge || props.alt

        break
    }
  }

  img = <img src={props.imageUrl || src || imagePlaceHolder} alt={props.alt || alt} />

  return (
    <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
      {img}
    </ReactPlaceholder>
  )
}

ProductImage.propTypes = {
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
  vendorId: PropTypes.number,
  vendorType: PropTypes.string,
  ready: PropTypes.bool
}

export default ProductImage



// WEBPACK FOOTER //
// ./src/features/ProductImage/ProductImage.js